import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CoreLoggerService {
    public logError(message: string, data?: unknown): void {
        console.error('Error: ' + message, data);
    }

    public logWarning(message: string, data?: unknown): void {
        console.warn('Warning: ' + message, data);
    }

    public logDebug(message: string, data?: unknown): void {
        console.debug('Debug: ' + message, data);
    }

    public logInfo(message: string, data?: unknown): void {
        console.info('Info: ' + message, data);
    }

    public logSuccess(message: string, data?: unknown): void {
        console.log('Success: ' + message, data);
    }
}
